<template>
    <div>
        <div v-if="showInside" class="popup-active">
            <div class="charts-container" v-if="state.charts" v-click-outside="closeEvent">
                <header class="popup-title">
                    <h2 v-html="state.chartHeader.title"></h2>
                    <span class="popup-subtitle" v-if="state.chartHeader.subtitle">{{
                        state.chartHeader.subtitle
                    }}</span>
                    <svg @click="hide" v-if="showInside" class="icon popup-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </header>
                <div class="charts--summary" v-if="state.charts.units.length > 0">
                    <table class="charts--summary-nutrition">
                        <thead>
                            <tr>
                                <th colspan="2">
                                    <span>Näringsvärden</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(nutrition, value) in state.charts.summary">
                                <td>
                                    <span>{{ nutrition }}</span>
                                </td>
                                <td>
                                    <span>{{ value }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="charts--summary-unit">
                        <thead>
                            <tr>
                                <th colspan="2"><span>Måttenheter</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="unit in state.charts.units">
                                <td>
                                    <span>1 {{ unit.Enhet }}</span>
                                    <span>{{ unit.BearbetadForm }}</span>
                                </td>
                                <td>
                                    <span>{{ unit.Gram }} gram</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <charts :data="state.charts"></charts>
            </div>
        </div>
    </div>
</template>

<script>
import state from './../state.js';
import charts from './charts.vue';

export default {
    components: {
        charts: charts
    },

    data() {
        return {
            state,
            showInside: false,
            currentEvent: null
        };
    },

    directives: {
        'click-outside': {
            priority: 700,

            bind: function (el, binding, vnode) {
                let self = vnode.context;

                self.currentEvent = function (event) {
                    self.closeEvent(event);
                };

                el.addEventListener('click', (event) => event.stopPropagation());

                document.body.addEventListener('click', self.currentEvent);

                $('body').addClass('lock');
            },

            unbind: function (el, binding, vnode) {
                el.removeEventListener('click', (event) => event.stopPropagation());

                document.body.removeEventListener('click', self.currentEvent);

                $('body').removeClass('lock');
            }
        }
    },

    computed: {
        chartData: function () {
            return this.state.charts;
        }
    },

    watch: {
        chartData: function (newVal) {
            newVal ? this.show() : '';
        }
    },

    methods: {
        show() {
            this.showInside = true;
        },
        hide() {
            this.showInside = false;
            this.state.charts = null;
            this.state.chartHeader = {
                title: null,
                subtitle: null
            };
        },

        closeEvent(event) {
            event.stopPropagation();
            this.hide();
        }
    }
};
</script>
